module.exports = __webpack_public_path__ + "img/subroot.1d652636.svg";